import { useState, useRef } from "react"
import { Box, Stack, Heading, Text, Link, Button, Input, InputGroup } from "@chakra-ui/react"
import axios from "axios"

export default function EmailSignup({ description = true, headerColor = "#333" }) {
    const [formState, setFormState] = useState("init") // init, submitting, error, thanks
    const [emailAddress, setEmailAddress] = useState("")
    const honeyPotRef = useRef()

    async function submit() {
        if (!validateEmail(emailAddress)) {
            setFormState("error")
            return false
        }

        setFormState("submitting")

        const body = {
            email: emailAddress,
            the_field: honeyPotRef.current.value,
        }

        // submit to server before submitting to Pardot
        await axios
            .post("/api/forms/newsletter", body)
            .then(response => {
                if (response.data.success) {
                    setFormState("thanks")
                } else {
                    setFormState("error")
                }
            })
            .catch(error => {
                setFormState("error")
            })
    }

    function handleKeyup(event) {
        if (event.keyCode == 13) {
            submit()
        }
    }

    function validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+$/
        return re.test(String(email).toLowerCase())
    }

    return (
        <Box>
            <Box>
                {description && (
                    <>
                        <Heading as="h4" fontFamily="heading" fontSize="15px" color={headerColor} my={0}>
                            Sign Up for Our Newsletter
                        </Heading>
                        <Text mt={1} mb={0} fontSize="13px">
                            Get the latest news and information from CRF.
                        </Text>
                        <Text mt={1} mb={4}>
                            By submitting your email address, you agree to{" "}
                            <Link href="https://www.crf.org/privacy-policy" textDecoration="underline" target="_blank">
                                CRF&apos;s Privacy Policy
                            </Link>{" "}
                            &{" "}
                            <Link
                                href="https://www.crf.org/terms-and-conditions-of-use"
                                textDecoration="underline"
                                target="_blank"
                            >
                                Terms and Conditions of Use
                            </Link>
                            .
                        </Text>
                    </>
                )}

                {formState === "thanks" ? (
                    <Text color="red" fontSize="18" fontWeight={600}>
                        Thank you for signing up.
                    </Text>
                ) : (
                    <Stack direction="horizontal" gap={0} className="light">
                        <InputGroup size="md">
                            <>
                                <Input
                                    id="email"
                                    name="email"
                                    onKeyUp={handleKeyup}
                                    onChange={event => setEmailAddress(event.target.value)}
                                    borderRadius="0"
                                    backgroundColor={"white"}
                                    pr={1}
                                    color="#333"
                                    placeholder="Email address"
                                />
                                <Input
                                    pos="absolute"
                                    top="-9999px"
                                    left="-9999px"
                                    name="the_field"
                                    id="the_field"
                                    type="text"
                                    defaultValue=""
                                    ref={honeyPotRef}
                                />
                            </>
                        </InputGroup>
                        <Button
                            borderRadius="0"
                            px={5}
                            variant="subtle"
                            onClick={submit}
                            isLoading={formState === "submitting"}
                            loadingText="Submitting"
                        >
                            Submit
                        </Button>
                    </Stack>
                )}
                {formState === "error" && (
                    <Text color="red" mt={1}>
                        Please provide a valid email address.
                    </Text>
                )}
            </Box>
        </Box>
    )
}
